import {
    DRAWINGTOOLBAR_BACKGROUND_FILE_SELECTED,
    APPTOOLBAR_RESET_APP_STATE,
    PDFDIALOG_PAGE_SELECT,
    PDFDIALOG_PAGE_CHANGE,
    PDFDIALOG_NUM_PAGES_CHANGE,
    PDFDIALOG_CLOSE,
} from "../lib/types";

const initialState = {
    file: null,
    hidden: true,
    numPages: 0,
    pageNumber: 1,
};

export default ( state = initialState, action ) => {
    /* discriminate the action type */
    switch (action.type) {
        case DRAWINGTOOLBAR_BACKGROUND_FILE_SELECTED:
            return {
                ...state,
                file: action.payload,
                hidden: false,
            };

        case PDFDIALOG_PAGE_SELECT:
        case PDFDIALOG_CLOSE:
            /* return initial state, i.e. hide */
            return initialState;

        case PDFDIALOG_PAGE_CHANGE:
            return {
                ...state,
                pageNumber: action.payload,
            };

        case PDFDIALOG_NUM_PAGES_CHANGE:
            return {
                ...state,
                numPages: action.payload,
            };

        case APPTOOLBAR_RESET_APP_STATE:
            return initialState;

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/pdfdialog-reducer.js